import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { uploadConfirmingTabs } from '../../../routes/purchases';

const Funding = () => {
  const tabs = uploadConfirmingTabs();
  return <FingoPaper tabs={tabs} />;
};

export default Funding;
